module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (120).7f6276b8.jpg";